import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import common from 'constants/common';
import TreeDotsIcon from '../../icons/treeDotsIcon';

const customStyles = {
  option: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#eee !important' : styles.backgroundColor,
    color: isDisabled ? '#999 !important' : styles.backgroundColor,
    borderRadius: isDisabled ? '0 !important' : styles.borderRadius,
  }),
};

const SelectBox = ({
  defaultValue,
  valueChanged,
  options,
  isMulti,
  isDotIcon,
  isClearable,
  disabled,
  dataCy,
}) => {
  const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
      ...theme.colors,
      ...common.primaryColors,
    },
  });

  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <TreeDotsIcon />
    </components.DropdownIndicator>
  );

  return (
    <div data-cy={dataCy}>
      <Select
        options={options}
        isMulti={isMulti}
        defaultValue={defaultValue}
        classNamePrefix="input--select"
        theme={(theme) => selectTheme(theme)}
        components={isDotIcon ? { DropdownIndicator } : undefined}
        onChange={valueChanged}
        isClearable={isClearable}
        isDisabled={disabled}
        styles={customStyles}
      />
    </div>
  );
};

SelectBox.propTypes = {
  defaultValue: PropTypes.string,
  valueChanged: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape()),
  isMulti: PropTypes.bool,
  isDotIcon: PropTypes.bool,
  isClearable: PropTypes.bool,
  disabled: PropTypes.bool,
  dataCy: PropTypes.string,
};

export default SelectBox;
